const atualizarFamilias = (state, familias) => {
    state.familias = familias;
}

const atualizarFamilia = (state, familia) => {
    state.familia = familia;
}

export default {
    atualizarFamilias,
    atualizarFamilia
}